import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import ReactQuill, { Quill } from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import EditorToolbar, { modules, formats } from './EditorToolbar';

// Quill'in Delta sınıfını içe aktarın
const Delta = Quill.import('delta');

// Quill'in clipboard modülünü genişletin
const Clipboard = Quill.import('modules/clipboard');

class PlainClipboard extends Clipboard {
	onPaste(e) {
		e.preventDefault();
		const clipboardData = e.clipboardData || window.clipboardData;
		const text = clipboardData.getData('text/plain');
		const range = this.quill.getSelection();
		const delta = new Delta().retain(range.index).delete(range.length).insert(text);
		const index = text.length + range.index;
		this.quill.updateContents(delta, 'silent');
		this.quill.setSelection(index, 'silent');
		this.quill.scrollIntoView();
	}
}

Quill.register('modules/clipboard', PlainClipboard);

const TextEditor = ({ onChange, value }) => {
	const [editorHtml, setEditorHtml] = useState(value);
	const [rawHtml, setRawHtml] = useState();
	const [showRaw, setShowRaw] = useState(false);

	useEffect(() => {
		setEditorHtml(value);
	}, [value]);

	const handleChange = (html) => {
		setEditorHtml(html);
		onChange(html);
	};

	const handleChangeRaw = (event) => {
		setRawHtml(event.target.value);
	};

	const handleClickShowRaw = () => {
		const isEditingRaw = showRaw;
		setShowRaw(!isEditingRaw);
		if (isEditingRaw) {
			setEditorHtml(rawHtml);
			onChange(rawHtml);
		} else {
			setRawHtml(editorHtml);
		}
	};

	return (
		<div className={showRaw ? 'showRaw' : ''}>
			<div className="text-editor">
				<EditorToolbar onClickRaw={handleClickShowRaw} />
				{showRaw ? (
					<textarea className="raw-editor" onChange={handleChangeRaw} value={rawHtml} />
				) : (
					<ReactQuill value={editorHtml} onChange={handleChange} modules={modules} formats={formats} theme="snow" />
				)}
			</div>
		</div>
	);
};

TextEditor.propTypes = {
	onChange: PropTypes.func,
	value: PropTypes.string,
};

export default TextEditor;
